import React from "react";
import "moment-timezone";
import 'react-slidedown/lib/slidedown.css'
import Tooltip from "@material-ui/core/Tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCheckCircle, faExclamationTriangle, faHourglassHalf, faSpinner, faTimesCircle} from "@fortawesome/free-solid-svg-icons";

class EstadoParticipacaoCurso extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let icons_style = {marginRight: "5px"};
    let icons = {
      QUAL: <FontAwesomeIcon icon={faCheckCircle} color={"#16924a"} style={icons_style}/>,
      OK: <FontAwesomeIcon icon={faCheckCircle} color={"#00acc1"} style={icons_style}/>,
      PEND: <FontAwesomeIcon icon={faHourglassHalf} color={"#6a93a2"} style={icons_style}/>,
      PROG: <FontAwesomeIcon icon={faSpinner} color={"#1babbf"} style={icons_style}/>,
      NOK: <FontAwesomeIcon icon={faExclamationTriangle} color={"#fd9729"} style={icons_style}/>,
      REP: <FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"} style={icons_style}/>,
      ANUL: <FontAwesomeIcon icon={faTimesCircle} color={"#bb0000"} style={icons_style}/>
    };

    let {estado} = this.props;
    if (!estado || !estado.resultado) return null;

    if (estado.resultado.estado_progresso) return estado.resultado.estado_progresso.map(progresso => <span><FontAwesomeIcon icon={progresso.icone === 'check' ? faCheck : faHourglassHalf} color={"#1cacbf"}/> {progresso.texto}<br/></span>);

    return this.props.detailed ? <span style={this.props.large ? {fontSize: "1.3em"} : {}}>{icons[estado.resultado.codigo]} {estado.resultado.designacao}</span> : <Tooltip
      title={estado.resultado.designacao}
      placement={this.props.tooltipPlacement || "right"}
    ><span>{estado.resultado.estado_progresso || icons[estado.resultado.codigo] || estado.resultado.designacao}</span></Tooltip>;
  }
}

export default EstadoParticipacaoCurso;
